<template lang="pug">
.property-value-form
    MainTab(
        v-if="!hideMainTab && (property.article_required || valueOption.translationOrigin)"
        :value-option="valueOption"
        :prop-type="propType"
        :property="property"
        :date-format="dateFormat"
    )
    //- NOTE: product related properties can only be edited for new values
    .prices-only(v-else-if="hideMainTab")
        .alert.info
            p {{ $t('Only prices can be edited for existing values') }}
        PricesTab(
            :value-option="valueOption"
            :edit-pivot="true"
            :options-prop="options"
            :inherited-tax="inheritedTax"
        )
    el-tabs(v-else tab-position="left" stretch v-model="tab")
        el-tab-pane(name="main" :label="$t('Property Value')")
            MainTab(
                :value-option="valueOption"
                :prop-type="propType"
                :property="property"
                :date-format="dateFormat"
            )
        el-tab-pane(name="prices" :label="$t('Prices')")
            PricesTab(
                :value-option="valueOption"
                :options-prop="options"
            )
</template>

<i18n>
{
    "de": {
        "Property Value": "Attributwert",
        "Only prices can be edited for existing values": "Für bestehende Werte sind nur Preise pflegbar",
        "Value": "Wert",
        "Prices": "Preise"
    }
}
</i18n>

<script>
import MainTab from './MainTab'
import PricesTab from './PricesTab'

export default {
    name: 'PropertyValueOptionForm',
    props: {
        valueOption: {
            type: Object,
            required: true
        },
        propType: {
            type: Object,
            required: true
        },
        property: {
            type: Object,
            required: true
        },
        dateFormat: {
            type: String,
            required: false,
            default: 'yyyy-MM-dd'
        },
        options: {
            type: Object,
            required: true
        },
        hideMainTab: {
            type: Boolean,
            default: false
        },
        inheritedTax: {
            type: Object,
        },
    },
    data: () => ({
        activeTab: 'main'
    }),
    components: {
        MainTab,
        PricesTab,
    },
    computed: {
        tab: {
            get() {
                return this.activeTab;
            },
            set(value) {
                this.$emit('change-tab', value);
            }
        },
    }
}
</script>

<style lang="sass" scoped>
.property-value-form
    padding: 0 20px
    padding-top: 4px
.alert
    margin-top: 0
</style>
